// extracted by mini-css-extract-plugin
module.exports = {"user":"ActiveUser_user__1sJOp","name":"ActiveUser_name__3-1CA","avatar":"ActiveUser_avatar__1i6JR"};